import { Component, OnInit, ViewChild } from '@angular/core';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';

import * as moment from 'moment';

@Component({
  selector: 'precio-dialog-component',
  templateUrl: './precio-dialog.component.html',
  styleUrls: ['./precio-dialog.component.scss']
})
export class PrecioDialogComponent implements OnInit {

  public titulo: string = null;
  public responsable: any = {};
  public validador: any = {};
  public fecha: string = '';
  public isPizarraView: boolean = false;
  public producto = '';
  public fechaPublicacion = '';
  public mercado = '';

  constructor(public dialogRef: MdDialogRef<PrecioDialogComponent>) {

  }

  ngOnInit() {

  }

  closeDialog() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios/precio-dialog.component.ts